module.exports = __webpack_public_path__ + "static/media/transportation.bce14c41.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/transportation.jpeg
// module id = 394
// module chunks = 0